export const percentageFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
})

export const compactPercentageFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
  maximumSignificantDigits: 3,
  notation: "compact",
})

export const formatPercentage = (value: number) =>
  Number.parseFloat(value.toFixed(1))

export const usePercentage = (value: number) => {
  const formattedPercentage = formatPercentage(value)

  if (formattedPercentage === null || formattedPercentage === undefined)
    return "—"

  if (Math.abs(formattedPercentage) >= 1000) {
    return `${compactPercentageFormatter.format(formattedPercentage)}%`
  }

  return `${percentageFormatter.format(formattedPercentage)}%`
}
